<template>
  <!-- 查看意见反馈 -->
  <div>
    <el-dialog
      :title="$t('menu.feedback')"
      :visible.sync="dialogVisible"
      width="680px"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <!-- 反馈内容 -->
      <div class="feedback-content">
        <div class="feedback-tittle">{{ $t("pages.user.text12") }}:</div>
        <div class="contentBox">
          <div class="content">
            <pre style="width: 100%;white-space: pre-wrap;" v-html="this.currentOpinion.feedbackContent"></pre>
          </div>
        </div>
      </div>
      <el-divider v-if="currentOpinion.feedbackImages != '' & currentOpinion.feedbackImages !=null"></el-divider>
      <!-- 上传图片 -->
      <div class="feedback-img" v-if="this.currentOpinion.feedbackImages != '' & this.currentOpinion.feedbackImages !=null">
        <div class="img-title">{{ $t("pages.user.text21") }}:</div>
        <div class="img-box">
          <div
            class="demo-image"
            v-for="(item, id) in currentOpinion.feedbackImages"
            :key="id"
          >
            <el-image
              v-if="item"
              :src="item"
              :preview-src-list="currentOpinion.feedbackImages"
            >
            </el-image>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{ $t("button.close") }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  data() {
    return {
    };
  },
  props: ["dialogVisible", "currentOpinion"],
  methods: {
    // 关闭查看弹窗
    handleClose() {
      this.$emit("dialogClose");
    },
  },
};
</script>

<style scoped>
.demo-drawer__footer {
  display: flex;
  justify-content: flex-end;
}
.feedback-img {
  display: flex;
  flex-direction: column;
}
.demo-image {
  display: flex;
  width: 150px;
  height: 150px;
  flex-direction: column;
  margin-right: 10px;
  margin-bottom: 20px;
}
.contentBox {
  display: flex;
  border: 1px solid #faf0e6;
  background: #fff5ee;
  width: 100%;
  margin-top: 10px;
  border-radius: 5px;
}
.content {
  flex-wrap: wrap;
  margin: 10px;
}
.feedback-content {
  display: flex;
  flex-direction: column;
}
.feedback-tittle {
  font-size: 16px;
  font-weight: bold;
}
.img-title {
  font-size: 16px;
  font-weight: bold;
}
.img-box {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
}
.image {
  display: flex;
  flex-direction: row;
  height: 100px;
  width: 100px;
}
.imgName {
  width: 100px;
  text-align: center;
}
</style>
     